import React from 'react';
import { observer } from 'mobx-react-lite';
import { FormInputState } from 'src_common/common/mobx-utils/Form';
import { Label } from 'src/domains/layouts/shared/typography/Content.style';
import { SelectNative } from 'src/domains/layouts/shared/formComponents/Select/SelectNative';
import { OptionElement } from 'src/domains/layouts/shared/formComponents/Select/SelectNative.style';
import { SelectNativeStateOld } from 'src/domains/layouts/shared/formComponents/Select/SelectNativeStateOld.state';

interface SelectOptionsType {
    key: string;
    name: string;
}

interface OldSelectPropsType {
    className?: string;
    label?: string;
    defaultText?: string;
    stateValue: FormInputState<string>;
    selectOptions: Array<SelectOptionsType>;
    onChange?: () => void;
    dataTest?: string;
}

/**
 * @deprecated - Please use Select.tsx from layouts/shared instead
 */

export const OldSelect = observer(({ className, label, defaultText, stateValue, selectOptions, onChange, dataTest }: OldSelectPropsType) => {
    const [ state ] = React.useState(() => new SelectNativeStateOld(stateValue, onChange));

    return (
        <>
            {label === undefined ? null : <Label>{label}</Label>}

            <SelectNative
                className={className}
                dataTest={dataTest}
                onChange={state.onChange}
                value={stateValue.value}
            >
                {selectOptions.length > 0 ?
                    <>
                        {defaultText === undefined ? null :
                            <OptionElement
                                defaultValue={defaultText}
                                value=''
                                disabled
                                hidden
                            >
                                {defaultText}
                            </OptionElement>
                        }

                        {selectOptions.map((option: SelectOptionsType) => {
                            return (
                                <OptionElement
                                    key={`${option.key}-${option.name}`}
                                    value={option.key}
                                >
                                    {option.name}
                                </OptionElement>
                            );
                        })}
                    </> : null}
            </SelectNative>
        </>
    );
});
